import './index.scss';
import React, { useState } from 'react';
import { authService } from '../../pages/Authentication/authService';
import { useNavigate, useLocation } from 'react-router-dom';


// Simple OutsideClickHandler component
const OutsideClickHandler = ({ children, onOutsideClick, className }) => {
    const handleClick = (e) => {
        if (e.target.closest('.team-selector')) return;
        onOutsideClick();
    };

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    return <div className={className}>{children}</div>;
};

// Simple Eclipse and Expand icons as components
const Eclipse = () => (
    <div className="eclipse-icon">
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#1A1A1A' }} />
    </div>
);

// Simple Logout icon
const Logout = () => (
    <div className="logout-icon">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10.6667 11.3333L14 8L10.6667 4.66667" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 8H6" stroke="#1A1A1A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    </div>
);

// Simple isEmpty utility
const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
};

export const TeamSelector = () => {
    const [focus, setFocus] = useState(false);
    const [teams, setTeams] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(null);
    const navigate = useNavigate();
    const { pathname } = useLocation();

    React.useEffect(() => {
        // Get the active team from localStorage
        const activeTeam = authService.getActiveTeam();
        // Get all teams
        const allTeams = authService.getAllTeams();

        if (allTeams.length > 0) {
            setTeams(allTeams);
            if (!activeTeam) {
                const firstTeam = allTeams[0];
                setSelectedTeam(firstTeam);
                // Store active team in localStorage
                localStorage.setItem('activeTeam', JSON.stringify({
                    id: firstTeam.id,
                    name: firstTeam.name,
                    displayName: firstTeam.displayName
                }));
            } else {
                setSelectedTeam(activeTeam);
            }
        }
    }, []);

    const changeTeam = (team) => {
        let pathName;
        if (pathname.includes('campaign')) {
            pathName = 'campaign';
        } else if (pathname.includes('rule')) {
            pathName = 'rule';
        } else {
            pathName = 'campaign';
        }

        setSelectedTeam(team);
        setFocus(false);
        
        // Store active team in localStorage
        localStorage.setItem('activeTeam', JSON.stringify({
            id: team.id,
            name: team.name,
            displayName: team.displayName
        }));

        // Navigate to the appropriate path
        navigate(`/${pathName}`);
    };

    const handleLogout = () => {
        // Clear localStorage
        localStorage.removeItem('activeTeam');
        localStorage.removeItem('authToken');
        localStorage.removeItem('allTeams');
        
        // Navigate to login page
        navigate('/login');
    };

    return (
        <div className="team-selector">
            <OutsideClickHandler
                onOutsideClick={() => setFocus(false)}
                className="p-relative"
            >
                <div
                    className="flex flex-middle c-pointer"
                    onClick={() => setFocus(!focus)}
                >
                    <div className="ml-5 d-inline-block flex flex-middle">
                        <Eclipse />
                    </div>
                    <div className="fw-600 fs-14 lh-24 c-cms ml-2">
                        {selectedTeam?.displayName || 'Select Team'}
                    </div>
                </div>
                {focus && (
                    <div className="bg-secondary-100 dropdown c-pointer" style={{ border: 0 }}>
                        {!isEmpty(teams) &&
                            teams.map((team) => (
                                <div
                                    className={`fs-14 lh-24 fw-500 c-neutral-900 py-2 px-4 dropdown-item ${
                                        selectedTeam?.id === team.id ? 'selected' : ''
                                    }`}
                                    onClick={() => changeTeam(team)}
                                    key={team?.id}
                                >
                                    {team?.displayName}
                                </div>
                            ))}
                    </div>
                )}
            </OutsideClickHandler>
            <div 
                className="logout-button flex py-3 px-6 flex-between c-pointer"
                onClick={handleLogout}
            >
                <span className="fw-500 fs-14 lh-20 c-cms">Log out</span>
                <Logout />
            </div>
        </div>
    );
}; 